import type { ThemeType } from './lightTheme';
import lightThemeObject from './lightTheme';
import darkTheme from './darkTheme';

declare module 'styled-components' {
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/naming-convention
  export interface DefaultTheme extends ThemeType { }
}

export default {
  light: lightThemeObject as unknown as ThemeType,
  dark: darkTheme as unknown as ThemeType,
};
